// src/utils/token.js

// ✅ Get access token
export const getAccessToken = () => {
  return localStorage.getItem("token");
};

// ✅ Get refresh token
export const getRefreshToken = () => {
  return localStorage.getItem("refreshToken");
};

// ✅ Save tokens
export const saveTokens = (token, refreshToken) => {
  if (token) localStorage.setItem("token", token);
  if (refreshToken) localStorage.setItem("refreshToken", refreshToken);
};

// ✅ Remove tokens (for logout)
export const clearTokens = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("refreshToken");
};
